import ParticipationService from '@/services/participation.service';
import router from '@/router'
import participationService from "@/services/participation.service";
import axios from "axios";


export const participationModule = {
    namespaced: true,
    state: {
        requests: [],
        exam: null,
        labels: new Map(),
        questions: new Map(),
        answers: new Map(),
        activeQuestion: null,
        activeQuestionIndex: null,
        _oldActiveQuestion: null,
        timers: {},
    },
    getters: {
        questionIds(state) {
            return [...state.questions.keys()]
        },
        labelIds(state) {
            return [...state.labels.keys()]
        },
        activeQuestionIdx(state, getters) {
            if (!state.activeQuestion)
                return null
            return getters.questionIds.indexOf(state.activeQuestion.id)
        },
        activeLabelIdx(state, getters) {
            if (!state.activeQuestion)
                return null
            return getters.labelIds.indexOf(state.activeQuestion.label_id)
        },
        isPreviousQuestionAvailable(state, getters) {
            if (!state.activeQuestion)
                return false
            return getters.activeQuestionIdx > 0
        },
        isNextQuestionAvailable(state, getters) {
            if (!state.activeQuestion)
                return false
            return getters.activeQuestionIdx < getters.questionIds.length - 1
        },
        isLastQuestion(state, getters) {
            if (!state.activeQuestion)
                return false
            return getters.activeQuestionIdx + 1 === getters.questionIds.length
        },
        isQuestionRequired(state) {
            if (!state.activeQuestion)
                return false

            return state.activeQuestion.required_answer
        },
        isAnswerSet(state) {
            if (!state.activeQuestion)
                return false

            return state.answers.has(state.activeQuestion.id)
        },
        questionSelectedAnswer(state) {
            if (!state.activeQuestion || state.activeQuestion.type === "DETAILED")
                return false

            return state.activeQuestion.options.find(x => x.is_selected === true)
        },
        hasQuestionTimeLimit(state) {
            if (!state.activeQuestion)
                return false

            return state.activeQuestion.duration
        },
        isQuestionTimeReached(state) {
            if (!state.activeQuestion)
                return false

            return state.activeQuestion.time_left <= 0
        },
        isAnsweredAllQuestion(state) {
            if (!state.activeQuestion)
                return false

            let status = true

            state.questions.forEach(function (question) {
                if (!question.isAnswered)
                    status = false
            });

            return status
        },
        getNearestAvailableQuestion(state) {
            if (!state.questions)
                return false

            let targetQuestion = null;

            state.questions.forEach(function (question) {
                if (question.isAvailable && targetQuestion === null){
                    targetQuestion = question
                }
            });

            return targetQuestion
        }
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async enterExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "enterExam");
            return ParticipationService.enterExam(axiosSource, examId).then(async (data) => {
                commit('enterExam', data)

                await dispatch('clearRequest', "enterExam");
                if (data.duration)
                    dispatch('startExamTimer', data)

                return Promise.resolve(data)
            }).catch((error) => {
                return Promise.reject(error)
            })
        },
        async getQuestion({commit, dispatch, state, getters}, questionId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getQuestionExam");
            commit('clearActiveQuestion')
            commit('clearTimer', 'label')

            return ParticipationService.getQuestion(axiosSource, state.exam.id, questionId).then(async (data) => {
                commit('updateActiveQuestion', data)
                await dispatch('clearRequest', "getQuestionExam");
                if (data.time_left && data.time_left <= 0){
                    dispatch('getNextQuestion')

                    return Promise.reject(data)
                }

                state.activeQuestionIndex = getters.activeQuestionIdx

                if(data.has_intraction){
                    commit('updateAnswer', getters.questionSelectedAnswer)
                }

                if (data.duration)
                    dispatch('startQuestionTimer', data)

                if (data.label_id !== state.activeQuestion?.label_id) {
                    // TODO: WARN USER BEFORE SWITCHING TO ANOTHER LABEL
                    const newLabel = state.labels.get(data.label_id)
                    const oldLabel = state.labels.get(state.activeQuestion?.label_id)

                    if (oldLabel?.duration)
                        commit('clearTimer', 'label')

                    if (newLabel.duration)
                        dispatch('startLabelTimer', state.labels.get(data.label_id))
                }

                return Promise.resolve(data)
            }).catch((error) => {
                commit('restoreActiveQuestion')

                dispatch('alert/show', {
                    'color': 'danger',
                    'message': 'خطایی هنگام دریافت سوال رخ داد!',
                }, {root: true})

                if (error.response?.data?.message)
                    dispatch('alert/show', {
                        color: 'danger',
                        message: error.response.data.message,
                    }, {root: true})

                if (getters.getNearestAvailableQuestion)
                    return dispatch("getQuestion", getters.getNearestAvailableQuestion.id)
                else if (getters.getNearestAvailableQuestion === null)
                    return dispatch('finishExam')

            })
        },
        getPreviousQuestion({dispatch, getters}) {
            if (getters.activeQuestionIdx >= 1)
                return dispatch('getQuestion', getters.questionIds[getters.activeQuestionIdx - 1])
        },
        getNextQuestion({dispatch, getters}) {
            if (
                (getters.isQuestionRequired && getters.isAnswerSet) ||
                (getters.hasQuestionTimeLimit && getters.isQuestionTimeReached) ||
                (!getters.isQuestionRequired) ||
                (!getters.hasQuestionTimeLimit)
            ) {
                if (getters.questionIds.length < getters.activeQuestionIdx + 1 || getters.questionIds[getters.activeQuestionIdx + 1] === undefined)
                    return dispatch('finishExam')
                else{
                    return dispatch('getQuestion', getters.questionIds[getters.activeQuestionIdx + 1])
                }
            } else {
                dispatch('alert/show', {
                    'color': 'danger',
                    'message': 'پاسخ به این سوال اجباری میباشد.',
                }, {root: true})
            }
        },
        startQuestionTimer({commit, dispatch, state}, question) {
            const intervalID = setInterval(() => {
                commit('tickTimer', 'question')
            }, 1000)
            commit('setTimer', {
                timer: 'question',
                intervalID,
                seconds: question.time_left + 1,
                finishCallback() {
                    state.activeQuestion.time_left = 0
                    dispatch('getNextQuestion')
                }
            })
        },
        startLabelTimer({commit, dispatch, getters, state}, label) {
            const intervalID = setInterval(() => {
                commit('tickTimer', 'label')
            }, 1000)
            commit('setTimer', {
                timer: 'label',
                intervalID,
                seconds: label.duration + 1,
                finishCallback() {
                    dispatch('getQuestion', state.labels.get(getters.labelIds[getters.activeLabelIdx + 1]).interaction.question_ids[0])
                }
            })
        },
        startExamTimer({commit, dispatch}, exam) {
            const intervalID = setInterval(() => {
                commit('tickTimer', 'exam')
            }, 1000)
            commit('setTimer', {
                timer: 'exam',
                intervalID,
                seconds: exam.duration + 1,
                finishCallback() {
                    dispatch('finishExam')
                }
            })
        },
        async submitAnswer({commit, state, dispatch}, answer) {
            const axiosSource = await dispatch('makeOrCancelRequest', "submitAnswerQuestion");
            return ParticipationService.submitAnswer(
                axiosSource, state.exam.id, state.activeQuestion.id, answer
            ).then(async () => {
                commit('updateAnswer', answer)
                await dispatch('clearRequest', "submitAnswerQuestion");
            }).catch((error) => {
                dispatch('alert/show', {
                    'color': 'danger',
                    'message': 'خطایی هنگام ارسال پاسخ رخ داد!',
                }, {root: true})

                if (error.response?.data?.message)
                    dispatch('alert/show', {
                        color: 'danger',
                        message: error.response.data.message,
                    }, {root: true})
            })
        },
        async finishExam({state, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "finishExam");
            participationService.finishExam(axiosSource, state.exam.id).then(async () => {
                dispatch('alert/show', {
                    'color': 'success',
                    'message': 'آزمون شما به پایان رسید!',
                }, {root: true})
                await dispatch('clearRequest', "finishExam");

                router.push('/panel/home')
            }).catch(() => {
                dispatch('alert/show', {
                    'color': 'success',
                    'message': 'آزمون شما به پایان رسید!',
                }, {root: true})

                router.push('/panel/home')
            });


        }
    },
    mutations: {
        enterExam(state, exam) {
            const labels = exam.labels
            delete exam.labels
            state.exam = exam

            state.labels = new Map()
            for (const entity of labels) {
                state.labels.set(entity.id, entity)

                for (const question of entity.interaction.questions)
                    state.questions.set(question.id, {
                        id: question.id,
                        label_id: entity.id,
                        isAvailable: question.is_available,
                        isSeen: question.is_seen,
                        isAnswered: question.is_answer,
                    })
            }
        },
        clearActiveQuestion(state) {
            state._oldActiveQuestion = state.activeQuestion
            state.activeQuestion = null
        },
        restoreActiveQuestion(state) {
            state.activeQuestion = state._oldActiveQuestion
            state.questions.get(state._oldActiveQuestion.id).isAvailable = true
            state._oldActiveQuestion = null
        },
        updateActiveQuestion(state, question) {
            state.questions.get(question.id).isSeen = true
            state.questions.get(question.id).isAvailable = true

            if (state.questions && state._oldActiveQuestion && state.exam){
                if(state.exam.allow_return_to_previous_question === false){
                    state.questions.get(state._oldActiveQuestion.id).isAvailable = false
                }
            }

            state.activeQuestion = question
        },
        updateAnswer(state, answer) {
            if (!state.answers.has(state.activeQuestion.id)) {

                state.questions.get(state.activeQuestion.id).isAnswered = true

                state.answers.set(state.activeQuestion.id, {
                    option_id: answer?.optionId,
                    content: answer?.content,
                    file_id: answer?.fileId,
                })
            }
        },
        setTimer(state, {timer, intervalID, seconds, finishCallback}) {
            clearInterval(state.timers[timer]?.intervalID)
            state.timers[timer] = {
                intervalID,
                seconds,
                finishCallback,
            }
        },
        tickTimer(state, timer) {
            if (state.timers[timer].seconds <= 0) {
                clearInterval(state.timers[timer].intervalID)
                state.timers[timer].finishCallback(state)
            }
            else
                state.timers[timer].seconds -= 1
        },
        clearTimer(state, timer) {
            clearInterval(state.timers[timer]?.intervalID)
            delete state.timers[timer]
        },
    }
};